import { drcApproveToDoFilter } from '../../../DRCApproval/components';
import * as React from 'react';
import { DriveFileRenameOutline } from '@mui/icons-material';
import { useAuth } from '../../../../../contexts';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
  type CustomAction,
  type ApplicationViewTableDataItem,
} from '../../../../Application/components/ApplicationViewList';
import { APPLICATION_STATUS_TYPE } from '../../../../../utils';

export const DRCApprovalToDoList: React.FunctionComponent = () => {
  const { user } = useAuth();

  const handleEditAssessment = (row: ApplicationViewTableDataItem): void => {
    window.open(
      '/internal/drc-homepage/drcapproval/details/' + row.applicationId,
    );
  };

  const customActions: CustomAction[] = [
    {
      icon: <DriveFileRenameOutline />,
      handleAction: handleEditAssessment,
      checkDisable: row => {
        const status = row.applicationStatusRaw;
        return !(status === APPLICATION_STATUS_TYPE.UNDER_DSRC);
      },
    },
  ];

  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'department',
      'partnerCategory',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'gsAssignee',
    ],
    [],
  );

  const listFilter = drcApproveToDoFilter(user);

  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'applyProgramme',
      'department',
      'entryYear',
      'researchAreas',
      'confirmedChiefSupervisor',
      'nominatedFundings',
      'hkpfsDisplayInformation',
      'applicationStatus',
    ],
    [],
  );

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    customActions,
  };

  return (
    <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
  );
};
